import { render, staticRenderFns } from "./BadgeBoolean.vue?vue&type=template&id=128badd2"
import script from "./BadgeBoolean.vue?vue&type=script&lang=js"
export * from "./BadgeBoolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports